import { NavLink, Outlet } from "react-router-dom";
import { legalSections } from "@/pages/legal/lib";

/**
 * Layout de la sección legal: navegación lateral en escritorio, pestañas
 * horizontales deslizables en móvil y contenedor "liquid glass" para el contenido.
 */
export default function LegalLayout() {
  return (
    <div className="mx-auto w-full max-w-6xl px-4 py-8 md:px-6 md:py-12">
      <div className="mb-8">
        <p className="text-xs font-semibold uppercase tracking-wider text-secondary-600">
          Centro Legal
        </p>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          Consulta los términos, políticas y normas que rigen el uso de VendeYa.
          Actualizamos estos documentos periódicamente para reflejar cambios en el
          servicio y en la normativa vigente.
        </p>
      </div>

      {/* Pestañas horizontales (móvil/tablet) */}
      <nav className="mb-6 flex gap-2 overflow-x-auto no-scrollbar pb-1 lg:hidden">
        {legalSections.map((s) => (
          <NavLink
            key={s.id}
            to={s.path}
            className={({ isActive }) =>
              `flex shrink-0 items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? "border-primary-500 bg-primary-500 text-white"
                  : "border-background-200/70 bg-background-100 text-foreground-700 hover:bg-background-200"
              }`
            }
          >
            <i className={`${s.icon} text-base`}></i>
            <span className="whitespace-nowrap">{s.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="flex flex-col gap-8 lg:flex-row lg:items-start">
        {/* Navegación lateral (escritorio) */}
        <aside className="hidden w-64 shrink-0 lg:block">
          <nav className="glass sticky top-24 flex flex-col gap-1 rounded-lg p-2">
            {legalSections.map((s) => (
              <NavLink
                key={s.id}
                to={s.path}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-500 text-white"
                      : "text-foreground-700 hover:bg-background-200/70"
                  }`
                }
              >
                <i className={`${s.icon} text-base`}></i>
                <span className="whitespace-nowrap">{s.label}</span>
              </NavLink>
            ))}
          </nav>
        </aside>

        {/* Contenido */}
        <article className="min-w-0 flex-1">
          <div className="glass rounded-lg p-6 md:p-10">
            <Outlet />
          </div>
        </article>
      </div>
    </div>
  );
}